import _ from 'lodash';
import qs from 'qs';

export default function serializeQueryParams(params) {
  params = _.mapValues(params, (value) => {
    if (value instanceof Date) {
      value = value.toISOString();
    }
    return value;
  });

  return qs.stringify(_.omitBy(params, _.isNil));
}
